import Api from '@/services/api'

// Admin Forms API (behind the admin-gated /administration routes). Submission
// viewing + CSV export. The shared api.js factory attaches the Bearer token.
export default {
  // A page of submissions for a form. params: { page, pageSize }.
  listSubmissions (slug, params = {}) {
    return Api().get(`administration/forms/${encodeURIComponent(slug)}/submissions`, { params })
  },

  // The CSV export as a Blob (the endpoint sets Content-Disposition). Fetched via
  // axios so the Bearer token is sent; the caller turns the Blob into a download.
  exportSubmissions (slug) {
    return Api().get(`administration/forms/${encodeURIComponent(slug)}/submissions/export`, {
      responseType: 'blob',
    })
  },
}
